import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { AmipassInitInput } from 'src/app/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-amipass-recharge-modal',
  templateUrl: './amipass-recharge-modal.component.html',
  styleUrls: ['./amipass-recharge-modal.component.css']
})
export class AmipassRechargeModalComponent {
  @Output() balanceRecharge = new EventEmitter<number>();
  amount: number = 0;
  minimumRechargeAmount: number = environment.minimumRechargeAmount;
  maximumRechargeAmount: number = environment.maximumRechargeAmount;

  constructor(
    @Inject(MAT_DIALOG_DATA) public storeId: string,
    private dialogRef: MatDialogRef<AmipassRechargeModalComponent>,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private http: HttpService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  onSend() {
    if (this.amount >= this.minimumRechargeAmount && this.amount <= this.maximumRechargeAmount) {
      const encodedStoreId = encodeURIComponent(this.storeId)
      let amipassInitInput: AmipassInitInput = {
        amount: this.amount,
        urlExito: `${window.location.origin}/amipass/validate${this.storeId ? `?storeId=${encodedStoreId}` : ''}`,
        urlFracaso: `${window.location.origin}/amipass/decline${this.storeId ? `?storeId=${encodedStoreId}` : ''}`,
      }
      this.spinner.show();
      this.http.amipassInit(amipassInitInput).then((response) => {
        if (!response.successful) {
          console.log(response.message);
          this.snackBar.open("Algo salió mal al iniciar la transacción", "Cerrar", { duration: 3000 })
        }
        else {
          window.location.href = response.data;
        }
        this.spinner.hide();
      })
      .catch((error: HttpErrorResponse) => {
        console.log(error);
        this.snackBar.open("Algo salió mal al iniciar la transacción", "Cerrar", { duration: 3000 })
        this.spinner.hide();
      });
    };
  }
}
